export default __webpack_public_path__ + "static/media/info2c.2fb53f82.png";